import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import AutoComplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

const DrugPaySaved = (props) => {
  const { did } = useParams();

  const [patientData, setPatientData] = useState([]);
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '-');
  const [opbillData, setopbillData] = useState([]);
  const [consData, setConsData] = useState([]);
  const [disc, setDisc] = useState(0);
  const [viewPharmData, setViewPharmData] = useState([]);
  const [lres, setLres] = useState([]);
  const [lnet, setLnet] = useState([]);
  const [items, setItems] = useState([]);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [subtotal, setSubTotal] = useState(0);
  const [disPer, setDisPer] = useState(0);
  const [changed, setChanged] = useState(false);
  const nextQtyInputRef = useRef(null);
  const [drugData, setDrugData] = useState([]); // Declare drugData state variable
  const [pharmData,setpharmData]=useState({
        "sale_id":'',
        "sale_type":'',
        "pat":'',
        "patient":'',
        "cons":'',
        "product":'',
        "qty":'',
        "netamount":'',
        "total":'',
        "disc":'',
        "details":'',
        "paid":'',
        "balance":'',
        "mode":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
     });

  useEffect(() => {
    try {
      axios.get(`${baseUrl}pharm-save-view/${did}/`)
        .then(function (response) {
          const dataArray = Array.isArray(response.data) ? response.data : [response.data];
        setopbillData(dataArray);
        if (dataArray.length > 0 && dataArray[0].qty) {
          setLres(dataArray[0].qty.split(','));
        } else {
          // Handle the case where there's no data or qty is not present
          setLres([]);
        }
        });

    } catch (error) {
      console.log(error);
    }
  }, [did]);

  useEffect(() => {
  if (opbillData.length > 0) {

    fetchPharmData();
    fetchPharmData1();
    fetchConsData();
  }
}, [opbillData]);

     function fetchPharmData() {
const ipIds = opbillData.map(row => row.product.split(',').map(item => item.trim())).flat();

  // Create an array to store all promises
  const promises = ipIds.map(id =>
    axios.get(baseUrl + 'update-indent-use/' + id)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log(error);
        return null; // Return null for failed requests
      })
  );

  // Use Promise.all to wait for all requests to complete
  Promise.all(promises)
    .then(dataArray => {

      const filteredDataArray = dataArray.filter(data => data !== null);

      setViewPharmData(prevData => {

        const updatedData = prevData.map(row => {

          const matchedData = filteredDataArray.find(data => row.id === data.id);
          if (matchedData) {
            row.totqty = matchedData.qty;
          }
          return row;
        });
        return updatedData;
      });
    });
}

  function fetchPharmData1() {
  axios.get(`${baseUrl}indent-pharm-search/?dept=Pharmacy`)
    .then((pharmResponse) => {
      const ipIds = rows;
      console.log("Rows:", ipIds); // Log the contents of rows

      // Check if rows is not empty
      if(ipIds.length > 0) {
        console.log("Pharm Response Data:", pharmResponse.data); // Log the contents of pharmResponse.data

        // Update the viewPharmData based on matching ids
        setViewPharmData(pharmResponse.data.map(row => {
          const matchedData = ipIds.find(data => row.id === data.id);
          if (matchedData) {
            row.totqty = matchedData.qty;
          }
          return row;
        }));
      } else {
        // Handle the case when rows is empty
        console.log("No data selected");
        setViewPharmData(pharmResponse.data);
      }

      // Update the items state
      setItems(pharmResponse.data);
    })
    .catch(error => {
      console.log(error);
    });
}



  const handleKeyDown = (e, uniqueKey) => {
  const newRows = [...rows];
  switch (e.keyCode) {
    case 16: // Alt key
      e.preventDefault();
      handleAddRow();
      break;
    case 18: // Alt key
      e.preventDefault();
      handleDeleteRow(e, uniqueKey);
      break;
    default:
      break;
  }
};
const handleKeyDownr = (e, rowIndex) => {
  const newRows = [...rows];
  switch (e.keyCode) {
    case 16: // Alt key
      e.preventDefault();
      handleAddRow();
      break;
    case 18: // Alt key
      e.preventDefault();
      handleDeleteRowr(e, rowIndex);
      break;
    case 38: // Arrow up key
      e.preventDefault();
      if (newRows[rowIndex].selectedItem === 0) {
        newRows[rowIndex].selectedItem = items.length - 1;
      } else {
        newRows[rowIndex].selectedItem--;
      }
      setRows(newRows);
      break;
    case 40: // Arrow down key
      e.preventDefault();
      if (newRows[rowIndex].selectedItem === items.length - 1) {
        newRows[rowIndex].selectedItem = 0;
      } else {
        newRows[rowIndex].selectedItem++;
      }
      setRows(newRows);
      break;
    default:
      break;
  }
};

 useEffect(() => {
  setRows(rows);
  }, [rows]);

  const inputRefs = useRef([]);
  useEffect(() => {
    inputRefs.current[inputRefs.current.length - 1]?.focus();
  }, [rows.length]);

const handleAddRow = () => {
  const newRow = [{
  id: '',
  product: '',
  qty: '',
  batch: '',
  expiry: '',
  totqty: '',
  uamount: '',
  netamount: ''
}];
 setRows([...rows, newRow]);
 setDrugData([...drugData, newRow]);
};

const handleDeleteRowr = (e, rowIndex) => {
    e.preventDefault();
    const newRows = [...rows];
    newRows.splice(rowIndex, 1);
    setRows(newRows);
        inputRefs.current.splice(rowIndex, 1);

  };

  const handleDeleteRow = (e, uniqueKey) => {
      const [rowIndex, subIndex] = uniqueKey.split('-');
      const newOpbillData = [...opbillData];

      newOpbillData[rowIndex].product = newOpbillData[rowIndex].product
        .split(',')
        .filter((_, index) => index !== parseInt(subIndex))
        .join(',');

      const newLnet = lnet.filter((_, index) => index !== parseInt(subIndex));
      const newLres = lres.filter((_, index) => index !== parseInt(subIndex));

      // Update the indexes in newOpbillData
      newOpbillData.forEach((row) => {
        const products = row.product.split(',').map((product) => parseInt(product));
        const updatedProducts = products.map((product) => {
          if (product > parseInt(uniqueKey)) {
            return product; // Adjust the index of products after deletion
          }
          return product;
        });
        row.product = updatedProducts.join(',');
      });

      setLnet(newLnet);
      setLres(newLres);
      setopbillData(newOpbillData);
  };


 const handleChange = (e, index) => {
  const { name, value } = e.target;
  setpharmData(prevState => ({ ...prevState, [name]: value }));
};

 const handleChanger = (e, rowIndex) => {
  const { name, value } = e.target;
  setpharmData(prevState => ({ ...prevState, [name]: value }));
};

const handleSelect = (val, rowIndex, id) => {
  const selectedId = val;
  const selectedItem = val;

  if (!selectedItem) {
    console.log('Selected item not found');
    return;
  }

  const newRows = [...rows];


    const today = new Date(formattedDate);
    const expiry = new Date(selectedItem.product.expiry); // already YYYY-MM-DD

    // Calculate difference in days
    const diffTime = expiry.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays <= 0) {
    Swal.fire(`${diffDays} day(s) since expired`);
    return; // Prevent selection
  }

  // Check if the selected ID already exists in the rows
  const existingRowIndex = newRows.findIndex(row => row.id === selectedItem.id);
  if (existingRowIndex !== -1) {
    const remainQty = newRows[existingRowIndex].totqty - newRows[existingRowIndex].qty;
    if (remainQty <= 0) {
      Swal.fire("Stock not available");
      return; // Prevent increasing quantity
    }
    const addQty = Math.min(1, remainQty); // Add 1 or the remaining quantity, whichever is smaller
    newRows[existingRowIndex].qty += addQty;
    newRows[existingRowIndex].netamount = newRows[existingRowIndex].qty * newRows[existingRowIndex].uamount;
  } else {
    newRows[rowIndex] = {
      id: selectedItem.id,
      product: selectedItem.product.product,
      batch: selectedItem.product.batch,
      expiry: selectedItem.product.expiry,
      totqty: selectedItem.qty,
      uamount: selectedItem.product.uamount,
      qty: 1,
      netamount: selectedItem.product.uamount * 1,
    };
  }
  setRows(newRows);

  if (diffDays < 15) {
    Swal.fire(`${diffDays} day(s) to expire  totqty = ${selectedItem.totqty}`);
  }
  if (nextQtyInputRef.current) {
      nextQtyInputRef.current.focus();
    }
      const pharmData = viewPharmData.find((data) => data.id === parseInt(id));
};

const handleAmountChange = (e, subIndex) => {
  const newLnet = [...lnet];
  const qty = parseFloat(e.target.value);
  const uamount = parseFloat(e.target.getAttribute('data-uamount'));
  const totqty = parseFloat(e.target.getAttribute('data-totqty'));

   if (qty > totqty) {
    Swal.fire("Stock not available");
    const updatedQty = totqty.toString(); // Convert totqty to string
    const updatedLres = lres.map((item, i) =>
      i === subIndex ? updatedQty : item
    );
    setLres(updatedLres);
    e.target.value = updatedQty; // Update the input field value

  }
  const netamount = qty * uamount;
  newLnet[subIndex] = netamount;
  setLnet(newLnet);

};
const handleAmountChanger = (e, rowIndex) => {
    const newRows = [...rows];
    newRows[rowIndex].qty = parseFloat(e.target.value) || 0;
    newRows[rowIndex].uamount = parseFloat(newRows[rowIndex].uamount) || 1;
    const netamount = (newRows[rowIndex].qty * newRows[rowIndex].uamount).toFixed(2);
    newRows[rowIndex].netamount = parseFloat(netamount);
    const remainQty = newRows[rowIndex].totqty - newRows[rowIndex].qty;
    if (remainQty < 0) {
    Swal.fire("Stock not available");
    newRows[rowIndex].qty = newRows[rowIndex].totqty;
    newRows[rowIndex].netamount = parseFloat((newRows[rowIndex].totqty * newRows[rowIndex].uamount).toFixed(2));
    }
    setRows(newRows);
};

const handleDisPerChange = (e) => {
   const newDisPer = parseFloat(e.target.value) || 0;
   setDisPer(newDisPer);
  };


 useEffect(() => {
  let subTotal = 0;
  let disc = 0;
  let newTotal = 0;

  subTotal = arraySum(lnet); // Calculate subTotal based on arraySum

  if (rows.length > 0) {
    let subTotal1 = 0;
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      subTotal1 += row.netamount;
    }
    subTotal += subTotal1; // Add subTotal1 to the existing subTotal
  }

  disc = subTotal * (parseFloat(disPer) / 100);

  newTotal = subTotal - disc;

  setSubTotal(subTotal);
  setDisPer(disPer);
  setDisc(disc);
  setTotal(newTotal);
 }, [lnet, disPer, disc, rows]);

const arraySum = (arr) => {
    return arr.reduce((total, value) => total + parseFloat(value), 0);
  };

  function fetchConsData() {
    axios.get(`${baseUrl}cons-search/`)
      .then((consResponse) => {
        setConsData(consResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  const consul = opbillData.map(row => row.cons.id);
  const consultantOptions = consData.map((cons) => ({
      value: consul || cons.id,
      label: cons.consultant,
  }));

const handleConsChange = (event) => {
  const { value } = event.target;
  setpharmData((prevState) => ({
    ...prevState,
    cons: {
      id: value,
    },
  }));
};

const formSubmit = (e) => {
  e.preventDefault();
  const patid = document.getElementById("patid").value;
  const patient = document.getElementById("patient").value;
  const dbType = document.getElementById('dbType').value;
  const details = document.getElementById("details").value;
  const cons = document.getElementById("cons").value;

  const ids = [];
  let qtys = [];
  const netamounts = [];

  opbillData.forEach((row, index) => {
    const productParts = row.product.split(',');
    const productNumbers = productParts.map(part => Number(part.trim()));
    ids.push(...productNumbers);
    qtys.push(...lres.map(Number));
    netamounts.push(lnet);
  });

  const qtyMap = {};
  qtys.forEach((row, index) => {
    const elementId = `totqty-${index}`;
    const totqty = document.getElementById(elementId).value;
    qtyMap[ids[index]] = Number(totqty) - qtys[index];
  });

  const idsFromRows = rows.map(row => row.id);
  const qtysFromRows = rows.map(row => row.qty);
  const netamountsFromRows = rows.map(row =>  parseFloat(row.netamount).toFixed(2));
  const eqtys = rows.map(row => row.totqty);

  const totqtyMap = {};
  eqtys.forEach((totqty, index) => {
    const id = idsFromRows[index];
    totqtyMap[id] = totqty - qtysFromRows[index];
  });
    const drugData = [
        ...ids.map((id, index) => ({ id, qty: qtys[index] })),
        ...rows.map(row => ({ id: row.id, qty: row.qty })),
      ];

  const allIds = ids.concat(idsFromRows).join(',');
  axios.post(`${baseUrl}get_sale_pharm/`)
    .then(response => {
      const sale_id = response.data.value;
      const _formData = new FormData();
      _formData.append('sale_id', sale_id);
      _formData.append('sale_type', 'OtherBill');
      _formData.append('pat', patid);
      _formData.append('patient', patient);
      _formData.append('cons', cons);
      _formData.append('product', allIds);
      _formData.append('qty', qtys.concat(qtysFromRows).join(','));
      _formData.append('netamount', netamounts.concat(netamountsFromRows).join(','));
      _formData.append('total', total.toFixed(2));
      _formData.append('disc', disc.toFixed(2));
      if (dbType == 'creditpay') {
        _formData.append('paid', 0);
        _formData.append('balance', total.toFixed(2));
      } else {
        _formData.append('paid', total.toFixed(2));
        _formData.append('balance', 0);
      }
      _formData.append('mode', dbType);
      _formData.append('details', details);
      _formData.append('status', '1');
      _formData.append('addedby', userName);
      _formData.append('ip_add', ipAddress);
      _formData.append('location', userLocation);

      const updatePromises = drugData.map(drug => {
         const { id, qty } = drug;
         const pharmData = {
            id: id,
            qty: qty,
            ip_add: ipAddress,
          };
          return axios.post(`${baseUrl}update-indent-quantity/`, pharmData)
          .then(response => {
            console.log(response.data);
          })
          .catch(error => {
            console.log(error);
          });
      });
      Promise.all(updatePromises)
        .then(() => {
          axios.post(`${baseUrl}pharm-save-other/${did}/`, _formData)
            .then(response => {
              if (response.status === 200 || response.status === 201) {

                Swal.fire({
                  title: 'Pharmacy Bill Generated.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/pharm-invoice-other/' + sale_id;
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add entry. Please try again later.',
                'error'
              );
            });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to update drug quantities. Please try again later.',
            'error'
          );
        });
    })
    .catch(error => {
      console.log(error);
      Swal.fire(
        'Error!',
        'Failed to generate unique value. Please try again later.',
        'error'
      );
    });
};

useEffect(() => {
  const lnetDefaultValues = [];

  opbillData.forEach((row) => {
    row.product.split(',').forEach((test, subIndex) => {
      const pharmData = viewPharmData.find((data) => data.id === parseInt(test));
      const lnetDefaultValue = lres[subIndex] * (pharmData?.product.uamount || 0);
      lnetDefaultValues.push(lnetDefaultValue);
    });
  });

  setLnet(lnetDefaultValues);
}, [opbillData, viewPharmData, lres]);

const customFilterOptions = (options, state) => {
    const inputValue = state.inputValue.toLowerCase();

    if (inputValue.length < 3) {
      return [];
    }

    const filteredOptions = options.filter(option => {
      const label = (option.label || option.product?.product || '').toLowerCase();
      return label.startsWith(inputValue);
    });

    return filteredOptions;
  };
  return (
  <section className="container mt-4">
  <form>
   <div className="row table-responsive">
    <div className='col-md-12 col-12 mb-2'>
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Consultant</th>
        </tr>
      </thead>

      <tbody>
        {opbillData.map((pat, index) => {
        return(
          <tr key={index}>
            <td style={{width:'10%'}}><input className="form-control" type="text" name="patid" id="patid" value={pat.pat?.id} readOnly/></td>
            <td style={{width:'20%'}}><input className="form-control" type="text" name="patient" id="patient" value={pat.pat?.patient} readOnly/></td>

            <td>
                <select name="cons" id="cons"  onChange={handleConsChange} className="form-control">
                    {consData.map((category, index) => (
                    <option key={index} value={category.id} >
                      {category.consultant}
                    </option>
                  ))}
                </select>
            </td>
          </tr>
          );
        })}
      </tbody>
    </table>
    </div>
   </div>
    <div className='table-responsive'>
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th style={{width: 60}}>ID</th>
          <th style={{width: 150}}>Drug Name</th>
          <th style={{width: 50}} >Qty</th>
          <th style={{width: 100}}>Batch</th>
          <th style={{width: 90}}>Expiry</th>
          <th style={{width: 50}} >Qty in Stock</th>
          <th style={{width: 110}} >MRP 1s</th>
          <th style={{width: 110}}>Net Amount</th>
        </tr>
      </thead>

      <tbody>
    {opbillData.map((row, index) => {
      return row.product.split(',').map((test, subIndex) => {
        const pharmData = viewPharmData.find((data) => data.id === parseInt(test));
            const uniqueKey = `${index}-${subIndex}`;
            const defaultValueItem = items.find(item => item.product.product === pharmData?.product.product);

        return (
        <tr key={uniqueKey}>
        <td>
        <input
            type="text"
            name={`id-${index}`}
            id={`id-${index}`}
            value={pharmData?.id}
            onChange={(e) => handleChange(e, index)}
            style={{width: 60}}
            tabIndex={-1}
            readOnly
          />
          </td>
          <td>
           <AutoComplete
               value={defaultValueItem ? defaultValueItem : null}
          items={items}
          options={items}
          sx={{ width: 250 }}
          componentsProps={{
            paper: {
              sx: {
                width: 800
              }
            }
          }}
          fullWidth
          onKeyDown={e => handleKeyDown(e, uniqueKey)}
          onChange={(event, val, id) => handleSelect(val, index, id)}
              getOptionLabel={(option) => option.product ? option.product.product : ''}

               renderOption={(props, option) => (
                  <Box component="li" {...props}
                  fullWidth
                  sx={{
                  width: 750,
                  height: 50,
                  borderRadius: 1,
                    }}
                  >
                    {option.product ? `${option.product.product} ID: ${option.product.id} Expy: (${option.product.expiry}) 1s MRP: (${option.product.uamount}) Batch: ${option.product.batch}
                    TQty: ${option.qty} ` : ''}
                  </Box>

                )}
           renderInput={(params) => (
            <div ref={params.InputProps.ref}>
            <input className="form-control" type="text" {...params.inputProps} fullWidth focused autoFocus
               style={{
                  background: "#F7EEFF",
                  width: 250,
                  }}
             />
            </div>
           )}
            ref={(el) => inputRefs.current[index] = el}
           />
           </td>
          <td>
          <input
          type="number"
          style={{ width: 90 }}
          min={0}
          name={`qty-${index}`}
          id={`qty-${index}`}
          value={lres[subIndex]}
          data-uamount={pharmData?.product.uamount}
          data-totqty={pharmData?.qty}
          onChange={(e) => {
            const value = e.target.value;
            if (value >= 0) {
              const updatedLres = lres.map((item, i) =>
                i === subIndex ? value : item
              );
              setLres(updatedLres);
              handleAmountChange(e, subIndex);
            }
          }}
          onKeyDown={(e) => handleKeyDown(e, uniqueKey)}
          tabIndex={0}
          ref={nextQtyInputRef}
          required
        />

            </td>
          <td>
            <input
              type="text"

              style={{width: 120}}
              name="batch"
              value={pharmData?.product.batch}
              onChange={(e) => handleChange(e, subIndex)}
              tabIndex={-1}
            />
            </td>
          <td>
            <input
              type="text"

              style={{width: 90}}
              name="expiry"
              value={pharmData?.product.expiry}
              onChange={(e) => handleChange(e, subIndex)}
              tabIndex={-1}
            />
            </td>
          <td>
           {
              pharmData?.qty == 0 ? (
                handleDeleteRow(subIndex, uniqueKey)
              ) : (
                <input
                  type="number"

                  style={{ width: 90 }}
                  name={`totqty-${subIndex}`}
                  id={`totqty-${subIndex}`}
                  value={pharmData?.qty}
                  tabIndex={-1}
                  readOnly
                />
              )
            }
            </td>
          <td>
            <input
              type="number"

              style={{width: 90}}
              name="uamount"
              value={pharmData?.product.uamount}
              onChange={(e) => handleAmountChange(e, subIndex)}
              tabIndex={-1}
            />
            </td>
          <td>
            <input
              type="number"

              style={{width: 140}}
              name={`netamount-${index}`}
              id={`netamount-${index}`}
              value={lnet[subIndex]}
              tabIndex={-1}
              readOnly
            />
            </td>


             <button  className="btn btn-danger" style={{display: 'none'}} type="button" onClick={(e) => handleDeleteRow(e, uniqueKey)}>Delete</button>

        </tr>
        );

      });
    })}

    {rows && rows.length > 0 && rows.map((row, rowIndex) => (
        <tr key={rowIndex}>

        <td>
        <input
            type="text"
            name="id"

            value={row.id}
            style={{width: 60}}
            tabIndex={-1}
            readOnly
          />
          </td>
          <td>
          <AutoComplete
          value={items.find(item => item.product.product === row.product) || null}
          items={items}
          options={items}
          sx={{ width: 200 }}
          componentsProps={{
            paper: {
              sx: {
                width: 800
              }
            }
          }}
          fullWidth
          onKeyDown={e => handleKeyDownr(e, rowIndex)}
          onChange={(event, val, id) => handleSelect(val, rowIndex, id)}
          getOptionLabel={(option) => option.product ? option.product.product : ''}

           renderOption={(props, option) => (
              <Box component="li" {...props}
              fullWidth
              sx={{
              width: 750,
              height: 50,
              borderRadius: 1,
                }}
              >
                {option.product ? `${option.product.product} ID: ${option.product.id} Expy: (${option.product.expiry}) 1s MRP: (${option.product.uamount}) Batch: ${option.product.batch}
                TQty: ${option.qty} ` : ''}
              </Box>

            )}
           renderInput={(params) => (
            <div ref={params.InputProps.ref}>
            <input className="form-control" type="text" {...params.inputProps} fullWidth focused autoFocus
               style={{
                  background: "#F7EEFF",
                  }}
             />
            </div>
           )}
            ref={(el) => inputRefs.current[rowIndex] = el}
                filterOptions={customFilterOptions}
           />
          </td>
          <td>
                 <input
  type="number"
  style={{ width: 90 }}
  min={0}
  step="1"
  value={row.qty}
  name="qty"
  onChange={(e) => {
    let value = e.target.value;

    // Allow only whole numbers (no decimals)
    if (!/^\d*$/.test(value)) return;

    if (value === "" || Number(value) >= 0) {
      handleChanger(e, rowIndex);
      handleAmountChanger(e, rowIndex);
    }
  }}
  onKeyDown={(e) => {
    // Block decimal point and scientific notation
    if (e.key === "." || e.key === "e" || e.key === "-") {
      e.preventDefault();
    }
    handleKeyDownr(e, rowIndex);
  }}
  tabIndex={0}
  required
/>
            </td>
          <td>
            <input
              type="text"

              style={{width: 120}}
              name="batch"
              value={row.batch}
              onChange={(e) => handleChanger(e, rowIndex)}
              tabIndex={-1}
            />
            </td>
          <td>
            <input
              type="text"

              style={{width: 90}}
              name="expiry"
              value={row.expiry}
              onChange={(e) => handleChanger(e, rowIndex)}
              tabIndex={-1}
            />
            </td>
          <td>
            <input
              type="number"

              style={{width: 90}}
              name="totqty"
              value={row.totqty}
              onChange={(e) => handleChanger(e, rowIndex)}
              tabIndex={-1}
              readOnly
            />
            </td>
          <td>
            <input
              type="number"
              style={{width: 120}}
              name="uamount"
              value={row.uamount}
              onChange={(e) => {
                handleChanger(e, rowIndex);
                handleAmountChanger(e, rowIndex);
              }}
              tabIndex={-1}
            />
            </td>
          <td>
            <input
              type="number"

              style={{width: 140}}
              name="netamount"
              value={row.netamount}
              tabIndex={-1}
              readOnly
            />
            </td>

        <button  className="btn btn-danger" style={{display: 'none'}} type="button" onClick={(e) => handleDeleteRowr(e, rowIndex)}>Delete</button>

        </tr>
      ))}
      </tbody>
      </table>
    <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRow}>Add More</button>
  <div className="row ms-5 mt-5">

  <div className="col-md-6">
  <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
    <div className="form-group">
      <label style={{ fontWeight: 'bold' }}>Subtotal: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input type="number" onChange={handleChange} value={subtotal} readOnly />
      </div>
    </div>
    <div className="form-group mt-3">
      <label style={{ fontWeight: 'bold' }}>Discount: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">%</div>
        <input
          type="number"
          value={disPer}
          name="disPer"
          id="disPer"
          onChange={handleDisPerChange}
        />
      </div>
    </div>
    <div className="form-group mt-3">
      <label style={{ fontWeight: 'bold' }}>Discount Amount: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input
          type="number"
          onChange={handleChange}
          name="disc"
          id="disc"
          value={disc}
        />
      </div>
    </div>
    <div className="form-group mt-3">
      <label style={{ fontWeight: 'bold' }}>Total: &nbsp;</label>
      <div className="input-group">
        <div className="input-group-addon me-2 ">&#8377;</div>
        <input type="number" onChange={handleChange} name="tot" value={total} readOnly />
      </div>
    </div>
  </div>
  </div>
  <div className="col-md-6">
    <div className="form-group">
      <label>Choose Payment Type</label>
      <select name="dbType" id="dbType" >
        <option value="cash">Cash</option>
        <option value="card">Card</option>
        <option value="creditpay">Credit Payment</option>
        <option value="UPI">UPI</option>
      </select>
    </div>
    <div className="form-group">
      <label>Details:</label>
      <textarea
        className="no-comma form-control"
        tabIndex="0"
        name="details"
        id="details"
        rows={2}
        cols={2}
      ></textarea>
    </div>
  </div>
</div>
<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='mb-5' >
          <button type="button" onClick={formSubmit}  className="btn btn-primary mt-4">Submit</button>
</div>
    </div>
    </form>
  </section>
  );
};

export default DrugPaySaved;
